import { useState, useEffect } from "react";
import {  useHistory } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  InputGroup,
  Input 
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { taskmanageService } from "../../services/taskmanageService";
import 'assets/css/themecustom-style.css';
import { clientmanageService } from "../../services/clientmanageService";
import Paginationcomponent from "components/Paginationcomponent.js"

const ClientFrequency = (props) => {
  const user_info = JSON.parse(localStorage.getItem("user-info"));
 const history = useHistory();
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [frequencydata, setfrequencydata] = useState([]);
  const [client, setClientdata] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const [total_page,setTotalData] = useState(0);
  const handleRowsPerPageChange = (newRowsPerPage) => {
  
    setRowsPerPage(newRowsPerPage);
    
    setCurrentPage(1); 
    get_client_frequency(1,null,selectedFreq,selected_service,newRowsPerPage)
  
  };
  const handlePageClick = (e, index) => {
    e.preventDefault();
    get_client_frequency(index);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_client_frequency(prev);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_client_frequency(next);
  };
const[frencyLabel,setFrequencyLabel]=useState([]);
const [selectedFreq,setselectedFreq]=useState('');
  const get_client_frequency = async (pageNumber = 1,e,frequency='',service='',per_page=rowsPerPage) => { 
    let textbox = '';
    console.log(e)
    if(e != null){
      const value = typeof e === 'object' && e.target ? e.target.value : e;
      setClientdata(value);
      textbox = value;
    }
    clientmanageService.getcllientfrequency(pageNumber,textbox,frequency,service,per_page).then((response) => {
      console.log(response.data.freqncy_data)
      setfrequencydata(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setLastPageData(response.data.data.last_page);
      setFrequencyLabel(response.data.freqncy_data)
      setselectedFreq(response.data.active_freq);
      setTotalData(response.data.data.total);
    });
  };

  const restoreTask = (id,index) => {
    taskmanageService.restoreTask(id).then((response) => {
      if(response.status == 200){
        let state = [...frequencydata];
        delete state[index];
        setfrequencydata(state);
       toast.success(response.data.message);
      }else{
        toast.error(response.data.message);
      }
    });
  }

  useEffect(() => {
    get_client_frequency();
}, []);

const add_master = () => {
  history.push("/admin/addfreqmaster");
}
    function downloadReport(type){
     
      clientmanageService.fre_master_export(client,selectedFreq,selected_service,type).then((response) => {
      });
    }
    const [servicesData, setservicesData] = useState(['YearEnd','BookKeeping','PayRoll','IT','OffShore','Management Reporting','Hybrid','Admin services','TAT','Back Office','Customer Service','Finance & Accounting','Tax','SME']);

const[selected_service,seSelectedService]=useState('');
const serviceFilter = (e)=>{
  seSelectedService(e.target.value)
  get_client_frequency(1,client,selectedFreq,e.target.value)
}
const getClient = (id)=>{
  history.push("/admin/addfreqmaster/"+id);
}
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        
      <Row className="align-items-center row">
     
      <Col xl="8" lg="6">
        <Button
          className="dash-button"
          color="primary"
          type="button"
          onClick={() => add_master()}
        >
          + Master Data
        </Button>
      </Col>
    

            <Col lg="6">
            <div className="mb-0">
              <InputGroup className="input-group-alternative searchbox-container">
                <Input placeholder="Search client..." id="userdata" className="search-box" type="text"  onKeyDown={e => e.key === 'Enter' && get_client_frequency(1,e,selectedFreq,selected_service)}  />
                
              </InputGroup>
            </div>
            </Col>
            </Row>
        <Row className="mt-5">
          <div className="col" style={{padding:'0%'}}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="filter" >
                  <div className="col-12 d-flex">
                    <h3 className="mb-0" style={{fontSize:'20px'}}>Master data list</h3>
                    <select className="form-control ml-4 mt--2" name="service" onChange={(e)=>serviceFilter(e)} style={{width:'200px'}}>
                      <option value=''>Select Service</option>
                      {
                        servicesData.map(service => (
                          <option key={service} value={service}>{service}</option>
                        ))
                      }
                    </select>

                     <Button
                                          className="btn-icon-clipboard ml-4 mt--2"
                                          type="button"
                                          onClick={() => downloadReport(0)}
                                          style={{textAlign:'center',width:'180px'}}
                                          title="Download Report"
                                        >
                                        <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
                                        </Button>
                                        <Button
                                          className="btn-icon-clipboard ml-4 mt--2"
                                          type="button"
                                          onClick={() => downloadReport(1)}
                                          style={{textAlign:'center',width:'180px'}}
                                          title="Download Report"
                                        >
                                        <i className="fas fa-download" style={{fontSize:'14px'}}></i> All
                                        </Button>
                                        </div>
                                            
                </Row>
               
              </CardHeader>
              <br></br>
              <Row className="align-items-center row" >
              <div className="col-12" >
              {frencyLabel && frencyLabel.length > 0 && (
  <>
    {frencyLabel.map((freq, index) => (
      <button
        key={index}
        type="button"
        className={`btn text-center m-1 ${selectedFreq==freq.governance_freq ? 'btn-primary' : 'btn-secondary'}`}
        onClick={(e) => get_client_frequency(1,client,freq.governance_freq,selected_service)}
      >
         {freq.governance_freq}
         <Badge title="Approval Pending" className="badge-circle" color="danger" size="sm" style={{"position": "absolute","right": "-8px","bottom": "-7px","height":"1.1rem","width":"1.1rem","fontSize":"10px","color": "#fff","backgroundColor": "red"}}>
                       {freq.count}
                     </Badge>
      </button>
    ))}
  </>
)}

                   
                  </div>
                </Row>
                <br></br>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <th scope="col" className="whitespace">Company Name</th>
                    {selectedFreq =='All' ? 
                    <>
                    <th scope="col" className="whitespace">Frequency</th>
                    <th scope="col" className="whitespace">Months</th></>:null}
                    <th scope="col" className="whitespace">Services</th>
                    <th scope="col" className="whitespace">Director</th>
                    <th scope="col" className="whitespace">Client Manger</th>
                    <th scope="col" className="whitespace">Other Person</th>
                </thead>
                <tbody>
                  {frequencydata &&
                    frequencydata.length &&
                    frequencydata != null ? (
                      frequencydata.map((item, i) => (
                      <>
                     {/* <tr className={((item.governance_freq == null || item.governance_freq == '') ? 'red-row' : 'blue-row') }> */}
                     <tr  className={item.rating_color}>
                        <td className="whitespace" style={{cursor:'pointer'}} onClick={() => getClient(item.id)}>{item.name}</td>
                        {selectedFreq =='All' ? 
                        <>
                        <td className="whitespace">{item.governance_freq}</td>
                        <td className="whitespace">{item.freq_months}</td></> : null}
                        <td className="whitespace">{item.services}</td>
                        <td className="whitespace">{item.director}</td>
                        <td className="whitespace">{item.manager}</td>
                        <td className="whitespace">{item.other}</td>
                     </tr>
                      
                      </>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <CardFooter className="py-4">
              <div>
                     
                     <Paginationcomponent
                currentPage={currentPage}
                totalItems={total_page}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={rowsPerPageOptions}
                handlePageClick={handlePageClick}
                handlePreviousClick={handlePreviousClick}
                handleNextClick={handleNextClick}
                handleRowsPerPageChange={handleRowsPerPageChange}
                />
                       </div>
              </CardFooter>
            </Card>
          </div>
        </Row>
      
      </Container>
    </>
  );
};


export default ClientFrequency;
